(function () {
  'use strict';

  function initCountdown() {
    var timers = document.querySelectorAll('[data-countdown]');
    if (!timers.length) return;
    var now = new Date();
    var deadline = new Date(now.getTime() + (5 * 86400000) + (9 * 3600000) + (25 * 60000) + (54 * 1000));
    function update() {
      var diff = deadline - new Date();
      if (diff <= 0) { deadline = new Date(deadline.getTime() + 86400000); diff = deadline - new Date(); }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      timers.forEach(function (timer) {
        var dEl = timer.querySelector('[data-days]');
        var hEl = timer.querySelector('[data-hours]');
        var mEl = timer.querySelector('[data-mins]');
        var sEl = timer.querySelector('[data-secs]');
        if (dEl) dEl.textContent = days;
        if (hEl) hEl.textContent = hours;
        if (mEl) mEl.textContent = String(mins).padStart(2, '0');
        if (sEl) sEl.textContent = String(secs).padStart(2, '0');
      });
    }
    update();
    setInterval(update, 1000);
  }

  function initDynamicMonth() {
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var current = months[new Date().getMonth()];
    document.querySelectorAll('[data-current-month]').forEach(function (el) { el.textContent = current; });
  }

  function initPurchasesCounter() {
    var counters = document.querySelectorAll('[data-purchases-counter]');
    if (!counters.length) return;
    var now = new Date();
    var start = new Date(now.getFullYear(), 0, 0);
    var dayOfYear = Math.floor((now - start) / 86400000);
    var base = 1200 + (dayOfYear * 37) % 800;
    var count = base + Math.floor(now.getHours() * 12.7);
    counters.forEach(function (el) { el.textContent = count.toLocaleString(); });
    setInterval(function () { count += 1; counters.forEach(function (el) { el.textContent = count.toLocaleString(); }); }, 30000 + Math.random() * 60000);
  }

  function initShippingDate() {
    var els = document.querySelectorAll('[data-shipping-date]');
    if (!els.length) return;
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var formatted = tomorrow.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    els.forEach(function (el) { el.textContent = formatted; });
  }

  function initStickyCTA() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;
    var hero = document.querySelector('[data-hero]');
    if (!hero) { bar.classList.add('is-visible'); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) bar.classList.remove('is-visible');
        else bar.classList.add('is-visible');
      });
    }, { threshold: 0 });
    observer.observe(hero);
  }

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to], a[href^="#lp-"]');
      if (!link) return;
      var targetId = link.getAttribute('data-scroll-to') || link.getAttribute('href');
      if (!targetId || targetId.charAt(0) !== '#') return;
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  function initFAQ() {
    var faqItems = document.querySelectorAll('[data-faq-item]');
    faqItems.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) { other.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');
      if (!track) return;
      var currentIndex = 0;
      var total = track.children.length;
      function goTo(index) {
        if (index < 0) index = 0;
        if (index >= total) index = total - 1;
        currentIndex = index;
        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === currentIndex); });
      }
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
      var startX = 0, deltaX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; deltaX = 0; }, { passive: true });
      track.addEventListener('touchmove', function (e) { deltaX = e.touches[0].clientX - startX; }, { passive: true });
      track.addEventListener('touchend', function () { if (Math.abs(deltaX) > 50) { if (deltaX < 0) goTo(currentIndex + 1); else goTo(currentIndex - 1); } });
      goTo(0);
    });
  }

  function init() {
    initCountdown(); initDynamicMonth(); initPurchasesCounter(); initShippingDate();
    initStickyCTA(); initSmoothScroll(); initFAQ(); initCarousels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
